const cookieName = 'MyBravxAccessRequestSubmitted';

function createMarker(tenantId: string, objectId: string): string {
    return `${tenantId.toLowerCase()}:${objectId.toLowerCase()}`;
}

function hasSubmitted(tenantId: string, objectId: string): boolean {
    const cookiePrefix = `${cookieName}=`;
    const cookie = document.cookie
        .split(';')
        .map(value => value.trim())
        .find(value => value.startsWith(cookiePrefix));

    if (!cookie) {
        return false;
    }

    try {
        return decodeURIComponent(cookie.substring(cookiePrefix.length)) === createMarker(tenantId, objectId);
    } catch {
        return false;
    }
}

function markSubmitted(tenantId: string, objectId: string): void {
    const marker = encodeURIComponent(createMarker(tenantId, objectId));
    document.cookie = `${cookieName}=${marker}; Path=/; SameSite=Lax; Secure`;
}

(window as any).AccessRequests = { hasSubmitted, markSubmitted };